/**
 * Ensure a url is absolute, prepends baseUrl to all paths.
 * @param pathOrAbsolute
 * @returns
 */
export function standardizeUrl(
    baseUrl: string,
    pathOrAbsolute: string
): string {
    // Always return an absolute url
    const _absoluteUrl =
        pathOrAbsolute.slice(0, 4) !== 'http'
            ? baseUrl + pathOrAbsolute
            : pathOrAbsolute;

    // see: https://github.com/TypeNetwork/typenetwork.com/issues/4732
    // force the protocol to the one specified for the django client. This should
    // be https in all but development.
    const url = new URL(_absoluteUrl);
    url.protocol = new URL(baseUrl).protocol;
    return url.href;
}
